import { render, staticRenderFns } from "./preList.vue?vue&type=template&id=6afc0784&scoped=true&"
import script from "./preList.vue?vue&type=script&lang=js&"
export * from "./preList.vue?vue&type=script&lang=js&"
import style0 from "./preList.vue?vue&type=style&index=0&id=6afc0784&prod&lang=scss&"
import style1 from "./preList.vue?vue&type=style&index=1&id=6afc0784&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afc0784",
  null
  
)

export default component.exports